/**
 * MaterialTestingFieldButton - Material Testing field button using existing hooks
 */

import {useIsTestBooked} from '@hconnect/tuc-processes/fields/testing/useIsTestBooked'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FieldButton} from '../../FieldButton'

interface MaterialTestingFieldButtonProps {
  onClick: () => void
  requiresApproval?: boolean
  isReadOnly?: boolean
  isChanged?: boolean
}

export const MaterialTestingFieldButton: React.FC<MaterialTestingFieldButtonProps> = ({
  onClick,
  requiresApproval = false,
  isReadOnly = false,
  isChanged = false
}) => {
  const {t} = useTranslation()
  const {isTestBooked} = useIsTestBooked()

  const displayValue = isTestBooked
    ? t('orderIntake.rmc.steps.shared.materialTesting.yes', 'Yes')
    : t('orderIntake.rmc.steps.shared.materialTesting.no', 'No')

  return (
    <FieldButton
      label={t('orderIntake.rmc.orderManagement.editSteps.labels.materialTesting', 'Material testing')}
      value={displayValue}
      onClick={onClick}
      requiresApproval={requiresApproval}
      isReadOnly={isReadOnly}
      isChanged={isChanged}
    />
  )
}
